// extracted by mini-css-extract-plugin
module.exports = {"container":"DealsBanner_container__kgl1Y","header":"DealsBanner_header__VtCWk"};